import HTTPError from '../utils/http-error';
import { userLoggedInFetch } from '../../pages/_app';

export const redirect = (redirectTo: string): void => {
  if (window.top === window.self) {
    window.location.assign(redirectTo);
  } else {
    window.open(redirectTo, '_top'); // v4 top-window redirect; replaces v3 Redirect.Action.REMOTE
  }
};

export const fetcher = async <JSON = any>(app, input: RequestInfo): Promise<JSON> => {
  const fetch = userLoggedInFetch(app);
  const res = await fetch(input, {});
  const data = await res.json();

  if (!res.ok) {
    throw new HTTPError(res.status, res.statusText, null);
  }

  return data;
};
